import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { TranslocoModule } from '@ngneat/transloco';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-endpoints',
    standalone: true,
    imports: [MatCardModule, MatTooltipModule, TranslocoModule, DecimalPipe],
    templateUrl: './endpoints.component.html',
    styleUrl: './endpoints.component.scss',
})
export class EndpointsComponent {
    // isToggled
    isToggled = false;

    @Input() aliveCount: number = 0;

    @Input()
    set endpointCount(count: number) {
        this.countUp = count;
        this.count = 0;
    }
    countUp: number = 0;
    count: number = 0;

    constructor(public themeService: CustomizerSettingsService) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    countStop: any = setInterval(() => {
        if(this.countUp - this.count > 1000) {
            this.count += 100;
        }
        else if(this.countUp - this.count > 100) {
            this.count += 10;
        }
        else {
            this.count++;
        }
        if (this.count == this.countUp) {
            clearInterval(this.countStop);
        }
    }, 2);
}
